
import { PackageData } from "@/pages/CreatePackage";
import { TemplateStyle } from "../types";
import { companyName } from "../constants";
import { generateQrCode } from "../helpers";
import { renderCommonSection } from "../commonSections";

const renderSection = (sectionId: string, packageData: PackageData): string => {
  const common = renderCommonSection(sectionId, packageData);
  if (common !== null) return common;

  switch (sectionId) {
    case 'client': {
        const clientCompanyLogoHtml = packageData.companyLogoUrl ? `<img src="${packageData.companyLogoUrl}" alt="شعار شركة العميل" style="max-height: 40px; margin-bottom: 10px; border-radius: 4px;" />` : '';
        const companyNameHtml = packageData.companyName ? `<div class="card"><strong>الشركة:</strong> ${packageData.companyName}</div>` : '';
        return `<div class="section">
                    <h3>معلومات العميل</h3>
                    ${clientCompanyLogoHtml}
                    ${companyNameHtml}
                    <div class="card"><strong>جهة الاتصال:</strong> ${packageData.clientName}</div>
                    <div class="card"><strong>البريد الإلكتروني:</strong> ${packageData.clientEmail}</div>
                </div>`;
    }
    case 'hotels':
      if (packageData.hotels.length === 0) return '';
      return `<div class="section"><h3>الإقامة الفندقية</h3>${packageData.hotels.map(hotel => `<div class="card"><strong>${hotel.name}</strong> - ${hotel.nights} ليالي</div>`).join('')}</div>`;
    case 'flights':
      if (packageData.flights.length === 0) return '';
      return `<div class="section"><h3>رحلات الطيران</h3>${packageData.flights.map(flight => `<div class="card"><strong>${flight.airline}</strong>: ${flight.from} - ${flight.to}</div>`).join('')}</div>`;
    case 'tours':
      if (packageData.tours.length === 0) return '';
      return `<div class="section"><h3>الجولات</h3>${packageData.tours.map(tour => `<div class="card"><strong>${tour.name}</strong><br>${tour.description}</div>`).join('')}</div>`;
    case 'price':
      return `<div class="price-box"><div class="total">$${packageData.totalPrice}</div></div>`;
    default:
      return '';
  }
};

export const getTemplate5HTML = async (packageData: PackageData, settings: TemplateStyle): Promise<string> => {
  const columnsHtml = settings.columns.map(column => {
    const sectionsHtml = column.sections.map(section => renderSection(section.id, packageData)).join('');
    return `<div class="pdf-column">${sectionsHtml}</div>`;
  }).join('');

  const qrCodeData = await generateQrCode(`Package: ${packageData.packageName}\nClient: ${packageData.clientName}\nPrice: $${packageData.totalPrice}`);
  
  const logoHtml = settings.media?.logo ? `<img src="${settings.media.logo}" alt="Company Logo" style="max-height: 60px; margin-bottom: 15px;" />` : '';
  const backgroundStyle = settings.media?.background ? `background: url('${settings.media.background}') center center / cover no-repeat;` : `background: ${settings.colors.background};`;

  return `
    <!DOCTYPE html>
    <html dir="rtl" lang="ar">
    <head>
      <meta charset="UTF-8">
      <title>عرض سياحي - ${packageData.packageName}</title>
      <link href="https://fonts.googleapis.com/css2?family=Amiri:wght@400;700&display=swap" rel="stylesheet">
      <style>
        body { font-family: 'Amiri', serif; background-color: #fdfdfb; color: ${settings.colors.text}; }
        .container { max-width: 800px; margin: 20px auto; border: 1px solid #e2e8f0; box-shadow: 0 5px 15px rgba(0,0,0,0.05); ${backgroundStyle} }
        .header { padding: 30px; text-align: center; border-bottom: 2px solid ${settings.colors.primary}; background-color: rgba(255,255,255,0.8); }
        .header h1 { font-size: 32px; margin: 0; color: ${settings.colors.primary}; font-weight: 700; }
        .header p { font-size: 16px; color: #64748b; margin: 10px 0 0; }
        .content { padding: 30px; }
        .pdf-row { display: flex; flex-direction: row; gap: 20px; }
        .pdf-column { flex: 1; min-width: 0; }
        .section { margin-bottom: 25px; }
        .section h3 { font-size: 20px; color: ${settings.colors.primary}; margin-bottom: 15px; text-align: center; }
        .card { background-color: #fff; padding: 15px; border-radius: 4px; margin-bottom: 10px; border: 1px solid #f1f5f9; }
        .price-box { padding: 20px; background: ${settings.colors.primary}; color: #fff; text-align: center; margin-top: 30px; }
        .price-box .total { font-size: 32px; font-weight: 700; }
        .footer { text-align: center; color: #94a3b8; padding: 20px; font-size: 12px; border-top: 1px solid #e2e8f0; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          ${logoHtml}
          <h1>${packageData.packageName || 'عرض الفخامة الكلاسيكية'}</h1>
          <p>${packageData.destination} - ${packageData.duration}</p>
        </div>
        <div class="content">
           <div class="pdf-row">
            ${columnsHtml}
          </div>
          <div class="footer">
            <img src="${qrCodeData}" alt="QR Code" style="width:80px;height:80px;margin:10px auto;" />
            ${companyName}
          </div>
        </div>
      </div>
    </body>
    </html>
  `;
};
